module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/Jamal-510e06903514e764ab08b5b003d2d2bc.png";